import type { ReactNode } from "react";

/**
 * Rahmen für Tabellen im internen Bereich: horizontal scrollbar auf kleinen
 * Bildschirmen, fixierte Kopfzeile bei langen Listen.
 *
 * Verwendung:
 *   <AdminTableShell>
 *     <table className="w-full min-w-[720px] text-sm">…</table>
 *   </AdminTableShell>
 */
export function AdminTableShell({
  children,
  maxHeightClass = "max-h-[70vh]",
  className,
}: {
  children: ReactNode;
  maxHeightClass?: string;
  className?: string;
}) {
  return (
    <div
      className={
        "overflow-auto rounded-lg border border-border bg-background " +
        maxHeightClass +
        " [&_thead_th]:sticky [&_thead_th]:top-0 [&_thead_th]:z-10 [&_thead_th]:bg-secondary " +
        (className ?? "")
      }
    >
      {children}
    </div>
  );
}
